import React from "react";
import { Card } from "@mui/material";
import { useState, useEffect } from "react";
import DataTable from "examples/Tables/DataTable";
import SearchStringOrIntReq from "../../../Classes/Models/Requests/SearchStringOrIntReq";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import AccountingApi from "../../../Classes/API/AccountingApi";
import CreateDomesticExtraReq from "../../../Classes/Models/Requests/Accounting/CreateDomesticExtraReq";
import Swal from "sweetalert2";
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";
const ExtrasTable = ({ Stay, setIsLoaded }) => {
  const TableColumns = [
    { Header: "Id", accessor: "Id", align: "left" },
    { Header: "Extra Type", accessor: "ExtraType", align: "left" },
    { Header: "Description", accessor: "ExtraDescription", align: "left" },
    { Header: "Price", accessor: "ExtraPrice", align: "center" },
    { Header: "Quantity", accessor: "ExtraQuantity", align: "center" },
    { Header: "Total Price", accessor: "ExtraTotalPrice", align: "left" },
    { Header: "Quantity Received", accessor: "QuantityRecieved", align: "left" },
    { Header: "Remove", accessor: "Remove", align: "left" },
  ];
  const [TableDataRows, setTableDataRows] = useState([]);

  const RemoveExtra = async (Extra) => {
    const RemoveExtraReq = new SearchStringOrIntReq();
    RemoveExtraReq.SearchInt = Extra.id;

    var res = await AccountingApi.RemoveExtraFromDomesticStay(RemoveExtraReq);
    if (res.status == "Success") {
      Swal.fire({
        title: "Success",
        text: "Extra Removed Successfully",
        icon: "success",
        confirmButtonText: "OK",
      });
      setIsLoaded(false);
    } else {
      Swal.fire({
        title: "Error",
        text: res.message,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const UpdateQty = async (Extra) => {
    const UpdateQtyReq = new CreateDomesticExtraReq();
    UpdateQtyReq.Id = Extra.id;
    UpdateQtyReq.QuantityRecieved = document.getElementById(`${Extra.id}-QuantityRecieved`).value;
    var res = await AccountingApi.EditDomesticStayExtra(UpdateQtyReq);
    if (res.status == "Success") {
      Swal.fire({
        title: "Success",
        text: "Extra Quantity Updated Successfully",
        icon: "success",
        confirmButtonText: "OK",
      });
      setIsLoaded(false);
    } else {
      Swal.fire({
        title: "Error",
        text: res.message,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const MakeTableRow = (Extra) => {
    console.log(Extra);
    return {
      Id: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {Extra.id}
        </MDTypography>
      ),
      ExtraType: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {Extra.extraType}
        </MDTypography>
      ),
      ExtraDescription: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {Extra.extraDescription}
        </MDTypography>
      ),
      ExtraPrice: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {Extra.extraPrice}
        </MDTypography>
      ),
      ExtraQuantity: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {Extra.extraQuantity}
        </MDTypography>
      ),
      ExtraTotalPrice: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {Extra.extraTotalPrice}
        </MDTypography>
      ),
      QuantityRecieved: (
        <>
          <MDInput
            type="number"
            defaultValue={Extra.quantityRecieved}
            id={`${Extra.id}-QuantityRecieved`}
            label="Quantity Recieved"
          />
          <MDButton onClick={() => UpdateQty(Extra)}>Update</MDButton>
        </>
      ),
      Remove: (
        <MDTypography variant="button" color="text" fontWeight="medium">
          <MDButton
            onClick={() => {
              RemoveExtra(Extra);
            }}
          >
            Remove
          </MDButton>
        </MDTypography>
      ),
    };
  };

  const RefreshTable = (resList) => {
    var rows = [];
    resList.forEach((session, index) => {
      rows.push(MakeTableRow(session, index));
    });
    setTableDataRows(rows);
  };

  useEffect(() => {
    if (Stay.getExtras.length > 0) {
      RefreshTable(Stay.getExtras);
    } else {
      return (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          No Extras
        </MDTypography>
      );
    }
  }, [Stay]);

  return (
    <Card className="mt-5 mb-4">
      <MDBox
        mx={2}
        mt={-3}
        py={3}
        px={2}
        variant="gradient"
        bgColor="info"
        borderRadius="lg"
        coloredShadow="info"
      >
        <MDTypography variant="h6" color="white">
          Extras Table
        </MDTypography>
      </MDBox>
      <MDBox pt={3}>
        <DataTable
          table={{ columns: TableColumns, rows: TableDataRows }}
          isSorted={false}
          entriesPerPage={false}
          showTotalEntries={false}
          noEndBorder
        />
      </MDBox>
    </Card>
  );
};

export default ExtrasTable;
